import React, { useEffect, useState } from "react";
import "./admin.css";
import { Link } from "react-router-dom";
import ReactStars from "react-rating-stars-component";
import {
  getDatabase,
  ref,
  onValue,
  update,
  get,
  child,
} from "firebase/database";
import { toast } from "react-toastify";
export default () => {
  let [Lawyersarr, setLawyersarr] = useState([]);
  let [star, setStar] = useState("");
  let [currentRequest, setcurrentRequest] = useState({});
  useEffect(() => {
    const db = getDatabase();
    const starCountRef = ref(db, "/requests");
    onValue(starCountRef, (snapshot) => {
      let arr = [];
      snapshot.forEach((element) => {
        if (element.val().coustomer_uid === sessionStorage.getItem("uid")) {
          arr.push(element.val());
        }
        // arr.push(element.val());
      });
      setLawyersarr(arr);
    });
  }, []);

  const ratingChanged = (newRating) => {
    console.log(newRating);
    setStar(newRating);
  };

  let UpdateRatings = () => {
    console.log(star, currentRequest.business_Uid);
    if (star == "") {
      toast.warn("please Fill Stars");
      return;
    }
    const db = getDatabase();
    const starCountRef = ref(db, "lawyer/" + currentRequest.business_Uid);
    const starCountRef1 = ref(db, "/requests/" + currentRequest.uid);
    const dbRef = ref(getDatabase());
    get(child(dbRef, "lawyer/" + currentRequest.business_Uid)).then(
      (snapshot) => {
        const data = snapshot.val();

        let TotalRatings = data.TotalRatings;
        let Star1 = data.Star1;
        let Star2 = data.Star2;
        let Star3 = data.Star3;
        let Star4 = data.Star4;
        let Star5 = data.Star5;
        TotalRatings = TotalRatings + 1;
        if (star == 1) {
          Star1 = Star1 + 1;
        }
        if (star == 2) {
          Star2 = Star2 + 1;
        }
        if (star == 3) {
          Star3 = Star3 + 1;
        }
        if (star == 4) {
          Star4 = Star4 + 1;
        }
        if (star == 5) {
          Star5 = Star5 + 1;
        }

        update(starCountRef, {
          TotalRatings: TotalRatings,
          Star1: Star1,
          Star2: Star2,
          Star3: Star3,
          Star4: Star4,
          Star5: Star5,
          
        })
          .then(() => {
            console.log("Updated done");

            update(starCountRef1, {
              Feedback: "yes",
              Star: star,
            });

            window.location.href = "/lawyers/customer";
          })
          .catch((e) => {
            console.log(e);
          });
      }
    );
  };

  return (
    <>
      <div className="divwala">
        <div className="sidebarr">
          <a
            style={{ textTransformation: "uppercase !important" }}
            className="active"
            href="#home"
          >
            {sessionStorage.getItem("type")=== "Client"? 'CLIENT' : null} PANEL
          </a>

          {sessionStorage.getItem("type") === "Client" ? (
            <Link to={"/lawyers/customer"}>Request</Link>
          ) : null}
        </div>
        <div>
          <div>
            <div className="contentt">
              <table className="admin-data">
                <thead className="ishtyle">
                  <tr>
                    <th>Lawyer Name</th>
                    <th>Lawyer Email</th>
                    <th>Approved</th>
                    <th>Feedback</th>
                  </tr>
                </thead>
                <tbody>
                  {Lawyersarr.map((val, index) => {
                    // console.log(val);
                    return (
                      <tr key={index}>
                        <td>{val.Layer_name}</td>
                        <td>{val.laywer_email}</td>
                        {(val.approved === "Not Approved" && val.response === 'yes') ? (
                          <td >Rejected</td>
                        ) : (val.approved === "Not Approved" && val.response === 'no')?
                        <td>Waiting</td>

                        :
                          <td>Approved</td>
                        }
{console.log("cond>>>",val.Feedback == "yes" && val.approved == 'Approved')}
{
   val.approved == 'Approved'
  ?
  
 <>
 {
   val.Feedback == "yes" ? (
    <td>
      {val.Star}{" "}
      <img style={{width:15,height:15,margin:0,padding:0,marginTop:-5}} src="https://www.freepnglogos.com/uploads/star-png/star-vector-png-transparent-image-pngpix-21.png"></img>
    </td>
  ) : 
    <a href="#popup1">
      <button
        onClick={() => setcurrentRequest(val)}
        className="btn btn-secondary"
      >
        Share
      </button>
    </a>
 }</>
  :
  <td>Waiting</td>
}

                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div id="popup1" class="overlay">
          <div class="popup">
            <a class="close" href="#">
              &times;
            </a>
            <div class="content">
              <h4>Give Us your Feedback</h4>
              <ReactStars
                count={5}
                onChange={ratingChanged}
                size={50}
                isHalf={false}
                emptyIcon={
                  <i style={{ fontSize: 30 }} className="far fa-star"></i>
                }
                halfIcon={
                  <i
                    style={{ fontSize: 30 }}
                    className="fa fa-star-half-alt"
                  ></i>
                }
                fullIcon={
                  <i style={{ fontSize: 30 }} className="fa fa-star"></i>
                }
                activeColor="#ffd700"
                style={{ display: "none" }}
              />
              <button
                onClick={() => UpdateRatings()}
                className="btn btn-danger"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
